import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./PhotoFeeling.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";

const PhotoFeeling = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);
    const [rankTypeIndex, set_rankTypeIndex] = useState(0);
    const [rankType, set_rankType] = useState([
        { id: 1, label: "紓壓放鬆", img: "./assets/ui/Emoji1.png",img2: "./assets/ui/Emoji1_2.png" },
        { id: 2, label: "健康活力", img: "./assets/ui/Emoji2.png",img2: "./assets/ui/Emoji2_2.png" },
        { id: 3, label: "超值體驗", img: "./assets/ui/Emoji3.png",img2: "./assets/ui/Emoji3_2.png" },
        { id: 4, label: "精實鍛錬", img: "./assets/ui/Emoji4.png",img2: "./assets/ui/Emoji4_2.png" },
        { id: 5, label: "驚險刺激", img: "./assets/ui/Emoji5.png",img2: "./assets/ui/Emoji5_2.png" },
        { id: 6, label: "人潮擁擠", img: "./assets/ui/Emoji6.png",img2: "./assets/ui/Emoji6_2.png" },
    ]);
    useEffect(() => {
        console.log("PhotoFeeling");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }, [])

    function releseHand(e) {
        console.log("scrollableRef.current.scrollTop",scrollableRef.current.scrollTop,scrollableRef.current.clientHeight * .9)
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight * .9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                console.log("releseHand")
                arg.cb(-1);
                setInProp(false);
            }, 1000);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }

    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "PhotoFeeling"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                {
                                    console.log("scrollTop")
                                    arg.cb(-1);
                                    setInProp(false);
                                }
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    <div className={styleUi.bg}>
                                        <div className={styleUi.bar}>
                                        </div>
                                    </div>
                                    <div className={styleUi.view}>
                                        <YStyled.Span className={styleUi.title} size={20} >恭喜完成野放！感受如何？</YStyled.Span>
                                        <div className={styleUi.content}>
                                            <div className={styleUi.feeling}>
                                                {rankType.map((v, k) => {
                                                    return <YStyled.Col style={{  cursor: "pointer" }} align="center" gap=".4rem" key={k} onClick={e => {
                                                        set_rankTypeIndex(k);
                                                    }}>
                                                        <img src={(k === rankTypeIndex)?v.img2:v.img} style={(k === rankTypeIndex) ? { border: "solid #000", borderRadius: "50%",background:"#FFFBB1",borderWidth:"2px" } : {}} />
                                                        <YStyled.Span>{v.label}</YStyled.Span>
                                                    </YStyled.Col>
                                                })}
                                            </div>
                                            <YStyled.BTN2 style={{ width: "100%", background: "#000000", color: "#fff", padding: ".8rem" }} onClick={e => {
                                                console.log("sel")
                                                arg.cb(rankTypeIndex+1);
                                                setInProp(false);
                                            }}>
                                                <YStyled.Span size={17} >送出</YStyled.Span>
                                            </YStyled.BTN2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(PhotoFeeling);